<template>
	<div>
		<!-- swiper 插件 轮播图 -->
		<div class="banner-swiper">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="(item, index) in swipers" :key="index" @click="openWindow(item.redirectUrl)">
					<video :src="item.videoUrl" muted autoplay loop v-if="item.type===1"></video>
					<img :src="item.imgUrl" alt="" style="display: block;" v-if="item.type===2">
					<div class="text">
						<div class="title">{{item.title}}</div>
						<!-- <div class="more" v-if="item.redirectType" @click="openWindow(item.redirectUrl)">
              <span>了解更多</span>
            </div> -->
						<!-- <img class="more-img" src="../assets/images2/btn_more_01_nor@2x.png" alt="">
                <span class="more">了解更多</span>
              </img> --> 
					</div>
					<div class="backdrop"></div>
				</div>
			</div>
			<!-- 如果需要分页器 -->
			<div class="number">
				<div class=cur>0{{cur}}</div>
				<div class=total> / 0{{swipers.length}}</div>
			</div>
			<div class="swiper-pagination"></div>
			<img class="banner_icon_mouse" src="../assets/images2/banner_icon_mouse@2x.png" alt="">
		</div>

		<!-- 内容容器 -->
		<div class="content-wrapper">
			<!-- 首页推荐产品 -->
			<section id="product" class="product" v-if="product.length">
				<div class="content">
					<div class="title-img">
						<img class="img" src="../assets/images2/home_title_product@2x.png" alt="">
					</div>
					<!-- <div class="desc" v-cloak>{{product[0].desc}}</div> -->
          <div class="desc" v-if="carouselIndex>=0">
            <template v-for="(item, index) in handleBrArr(product[carouselIndex].desc)">
              <div :key="index" class="item" v-if="item">
                <div class="text">{{item}}</div>
              </div>
            </template>
          </div>
					<div class="more-box" @click="openPage(`/product/details/${product[carouselIndex].rId}/${product[carouselIndex].templateId}`, 'product')">查看详情</div>
				</div>
				<div class="product-carousel" v-if="product.length">
          <el-carousel ref="productCarousel" arrow="never" :interval="5000" indicator-position="none" height="2.9rem" width="2.32rem" trigger="click" type="card" @change="changeCarousel">
            <el-carousel-item v-for="(item, index) in product" :key="index" :style=" 
                {backgroundImage:'url('+item.imgUrl+')'}">
              <div class="carousel-item-inner" @click="openPage(`/product/details/${item.rId}/${item.templateId}`)"></div>
              <!-- <h3 class="medium">{{ item }}</h3> -->
              <!-- <img :src="item.imgUrl" alt=""> -->
            </el-carousel-item>
          </el-carousel>
          <div class="swiper-btn swiper-left left-arrow" @click="changeProduct(-1)"></div>
          <div class="swiper-btn swiper-right right-arrow" @click="changeProduct(1)"></div>
          <div class="productName">{{product[carouselIndex].rTitle}}</div>
        </div>
				<!-- <div class="product-swiper-box">
					<div class="product-swiper">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(item, index) in product.imgs" :key="index" :style=" 
                {backgroundImage:'url('+item.img+')'}">
							</div>
						</div>
					</div>
					<div class="swiper-button-prev swiper-btn swiper-left"></div>
					<div class="swiper-button-next swiper-btn swiper-right"></div>
				</div> -->
			</section>
			<!-- 业务领域 -->
			<!-- :style=" {backgroundImage:'url('+business.bg+')'}" -->
			<section id="business" class="business" v-if="business.length">
				<!-- <img class="bg" :src="business.bg" alt=""> -->
				<div class="backdrop"></div>
				<div class="content" :style=" {backgroundImage:'url('+business[businessIndex].imgUrl+')'}">
					<div class="top">
						<div class="lists">
							<!-- :style="{backgroundImage:'url('+ item.status == 1 ? require('../assets/images2/home_business_nor@2x.png') : require('../assets/images2/home_business_sel@2x.png') +')'} -->
							<!-- :class="item.status==1?'home_business_nor_bg':'home_business_sel_bg'" -->
							<div v-for="(item, index) in business" :key="index" class="item" @mouseenter="changeServiceIndex(index, 'businessIndex')">
								<img :src="businessIndex == index ? require('../assets/images2/home_business_sel@2x.png') : require('../assets/images2/home_business_nor@2x.png')" alt="">
								<div class="text">{{item.rTitle}}</div>
							</div>
						</div>
						<div class="title-img">
							<img src="../assets/images2/home_title_business@2x.png" alt="">
							<div class="sub_title"> {{businessInfo.content}} </div>
						</div>
					</div>
					<div class="title">{{business[businessIndex].title}}</div>
					<div class="descs">
						<!-- <div class="item"> -->
							<!-- <img src="../assets/images2/home_business_tag@2x.png" alt=""> -->
							<!-- <div class="text">{{handleBrTag(business[businessIndex].desc)}}</div> -->
							<!-- <div class="text">{{handleBrTag(business[businessIndex].desc)}}</div> -->
							<!-- <div style=">white-space: pre-wrap;" v-html="handleBrTag(business[businessIndex].desc)"></div> -->
							<!-- <div style=">white-space: pre-wrap;" v-html="business[businessIndex].desc"></div> -->
						<!-- </div> -->
            <template v-for="(item, index) in handleBrArr(business[businessIndex].desc)">
              <div :key="index" class="item" v-if="item">
                <img src="../assets/images2/home_business_tag@2x.png" alt="">
                <div class="text">{{item}}</div>
              </div>
            </template>

					</div>
					<div class="more-box" @click="openPage(`/business/${business[businessIndex].rId}/${business[businessIndex].templateId}`)">查看更多</div>
				</div>
			</section>
			<section id="service" class="service">
				<div class="content">
					<div class="title-img">
						<img src="../assets/images2/home_title_service@2x.png" alt="">
					</div>
					<div class="lists">
						<div v-for="(item, index) in serviceLists" :key="index" class="item" @mouseenter="changeServiceIndex(index, 'serviceIndex')">
							<img class="" :src="serviceIndex === index ? item.imgUrl2 : item.imgUrl" alt="">
							<!-- <div class="img-box"> -->
							<!-- <img class="bg" v-if="item.status===1" src="../assets/images2/service_icon_bg_nor@2x.png" alt=""> -->
							<!-- <img class="bg" v-if="item.status===2" src="../assets/images2/home_business_sel@2x.png" alt=""> -->
							<!-- <img class="content-img" :src="item.status===1?item.img1:item.img2" alt=""> -->
							<!-- </div> -->
							<div class="text">{{item.title}}</div>
						</div>
					</div>
					<div class="industrys">
						<div class="laber">{{industrysInfo.content}}</div>
						<div class="lists">
							<div v-for="(item, index) in industrys" :key="index" class="item" >
                <div class="overlay-box"></div>
								<img :src="item.imgUrl" alt="">
								<div class="title">{{item.title}}</div>
								<div class="desc">{{item.content}}</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<!-- 关于我们， id用来导航菜单跳转 -->
			<section id="about-us" class="about-us">
				<div class="content">
					<div class="title-img">
						<img src="../assets/images2/home_title_about@2x.png" alt="">
					</div>
					<div class="title">{{aboutUsInfo.content}}</div>
					<span class="more-box" @click="openPage('/about')">查看更多</span>
					<div class="lists">
						<div v-for="(item, index) in aboutUs" :key="index" class="item" :class="{on: index==0}" :style=" 
            {backgroundImage:'url('+item.imgUrl+')'}">
							<!-- <img :src="item.img" alt=""> -->
							<div class="text-box">
								<div class="title">{{item.title}}</div>
                <div class="desc">
                  <template v-for="(item, index) in handleBrArr(item.desc)">
                    <div :key="index" class="item" v-if="item">
                      <div class="text">{{item}}</div>
                    </div>
                  </template>
                </div>
								<!-- <div class="desc">{{item.desc}}</div> -->
							</div>
						</div>
					</div>
				</div>
			</section>
			<!-- 合作客户 -->
			<section id="customer" class="customer">
				<div class="content">
					<div class="title-img">
						<img src="../assets/images2/home_title_customer@2x.png" alt="">
					</div>
					<div class="title">{{customerInfo.content}}</div>
					<div class="customer-swiper-box">
						<div class="customer-swiper">
							<div class="swiper-wrapper">
								<!-- <div class="swiper-slide" v-for="(item, index) in customer.lists" :key="index"> 
                    <img :src="item.img" alt="">
                  </div> -->
								<div class="swiper-slide" v-for="(item, index) in customerSwipers" :key="index">
									<div class="swiper-slide-item" v-for="(itemII, II) in item" :key="II" >
										<img :src="itemII.imgUrl" alt="">
									</div>
								</div>
							</div>
						</div>
						<div class="swiper-button-prev swiper-btn swiper-left"></div>
						<div class="swiper-button-next swiper-btn swiper-right"></div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>

  import mixins from '@/mixins';
	import Swiper from 'swiper';
	import { bannerList, indexDataList, getAppInfo, itemList } from '@/utils/api';
	export default {
    name: 'Index',
    mixins: [mixins],
		data() {
			return {
				screenWidth: 0,
				screenHeight: 0,
				vh: 0,
				activeNav: 'index',
				swipers: [],
				cur: 1,
				number: 10,
				product: [],
				business: [],
				businessIndex: 0,
				businessInfo: '',
				business2: [],
				services: {
					icon_bg1: require('../assets/images2/service_icon_bg_nor@2x.png'),
					icon_bg2: require('../assets/images2/service_icon_bg_sel@2x.png'),
					lists: [],
					industrys: [],
				},
				serviceLists: [],
				serviceIndex: 0,
				industrys: [],
				aboutUs: {
					title: '标语标语标语标语标语标语标语',
					lists: []
				},
				customer2: {
					title: '标语标语标语标语标语标语标语',
					lists: []
				},
				customer: [],
				aboutUsInfo: '',
        customerInfo: '',
        industrysInfo: '',
				productList: [
					{
						id: 1,
						titleType: '产品类型',
						title: '',
						childrens: [
							{
								id: '1-1',
								title: '产品名称',
							},
							{
								id: '1-2',
								title: '产品名称',
							},
							{
								id: '1-3',
								title: '产品名称',
							}
						],
					},
					{
						id: '2',
						titleType: '',
						title: '产品名称',
						childrens: []
					},
					{
						id: '3',
						titleType: '',
						title: '产品名称',
						childrens: []
					},
					{
						id: '4',
						titleType: '产品类型',
						title: '',
						childrens: [
							{
								id: '4-1',
								title: '产品名称',
							},
							{
								id: '4-2',
								title: '产品名称',
							},
							{
								id: '4-3',
								title: '产品名称',
							}
						],
					},
				],
				customerSwiperEl: '',
        showProductMenu: false,
        carouselIndex: -1,
        bannerSwiper: ''
			};
		},
		components: {},
		created() {
			this.$store.commit('activeNav', 'index');
			this.init();
		},
		computed: {
			customerSwipers() {
				let swipers = [];
				this.customer.forEach((d, i) => {
					// if (i < 8) {
					if (!swipers[Math.floor(i / 15)]) {
						swipers[Math.floor(i / 15)] = [];
					}
					swipers[Math.floor(i / 15)].push(d);
					// }
				});
				console.log('customerSwipers==', swipers);
				// this.customerSwiperEl && this.customerSwiperEl.update();
				return swipers;
			}
		},
		mounted() {
			var that = this;
			var bannerSwiper = new Swiper('.banner-swiper', {
				autoplay: {
					delay: 5000,
					disableOnInteraction: false
        },
        // loop: true, // 循环模式选项
        observer: true,
        observeParents:true,
				// 如果需要分页器
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				on: {
					init(swiper, e) {
            console.log('slideChange--swiper==', swiper);
            console.log('this.activeIndex==', this.activeIndex);
						// that.cur = ++this.activeIndex;
          },
          touchEnd(swiper, e) {
            console.log('touchEnd--swiper==', swiper);
            console.log('touchEnd--this.activeIndex==', this.activeIndex);
          },
					slideChange(event) {
            console.log('slideChange--event==', event);
            console.log('slideChange--this.activeIndex==', this.activeIndex);
            
						that.cur = this.activeIndex + 1;
						// that.cur = this.activeIndex > that.swipers.length ? this.activeIndex - that.swipers.length : this.activeIndex;
					}
				}
			});
			this.customerSwiperEl = new Swiper('.customer-swiper', {
        observer: true,
        observeParents:true,
				navigation: {
					nextEl: '.customer-swiper-box .swiper-button-next',
					prevEl: '.customer-swiper-box .swiper-button-prev',
				}
				// on: {
				// 	slideChangeTransitionEnd: function () {
				// 		if (this.isEnd) {
				// 			this.navigation.$nextEl.css('display', 'none');
				// 		} else {
				// 			this.navigation.$nextEl.css('display', 'block');
				// 		}
				// 	},
				// },
			});
		},
		methods: {
      changeProduct(index) {
        if (index == -1) {
          this.$refs.productCarousel.prev();
        } else {
          this.$refs.productCarousel.next();
        }
      },
      changeCarousel(index) {
        this.carouselIndex = index;
      },
			async init() {
        const banner = await bannerList();
        // const bannerLisr = await this.$fetch('/app/bannerList');
        console.log('index--banner==', banner);
        this.swipers = banner.data.baseData || [];
        this.bannerSwiper.up
        // console.log('index--this.swipers==', this.swipers);
				// this.getBanner();
				// 1是产品，2是业务，3是关于我们，4是合作客户
        this.product = await this.getData(1);
        
        this.carouselIndex = this.product.length ? 0 : -1;

				this.business = await this.getData(2);
				this.aboutUs = await this.getData(3);
				this.customer = await this.getData(4);
				console.log('this.business==', this.business);
				console.log('index--this.aboutUs==', this.aboutUs);
				console.log('this.customer==', this.customer);
				console.log('this.product==', this.product);

				// this.business = await this.getData(2);
				// 业务领域副标题
        // const res3 = await getAppInfo('key-index-m-business-title');
        // console.log('index--res3==', res3);
        
        const businessInfo = await getAppInfo('key-index-m-business-subTitle');
        this.businessInfo = businessInfo.data.baseData;
				console.log('init--this.businessInfo==', this.businessInfo);

				// 关于标题
        const aboutUsInfo = await getAppInfo('key-index-m-about-subTitle');
        this.aboutUsInfo = aboutUsInfo.data.baseData;
				console.log('init--this.aboutUsInfo==', this.aboutUsInfo);

				// 合作客户标题
        const customerInfo = await getAppInfo('key-index-m-customer-subTitle');
        this.customerInfo = customerInfo.data.baseData;
				console.log('init--this.customerInfo==', this.customerInfo);

				// 服务列表
				const res1 = await itemList({ type: 1, limit: 9 });
				this.serviceLists = res1.data.baseData || [];
				console.log('index--this.serviceLists==', this.serviceLists);

        // 行业列表
        const industrysInfo = await getAppInfo('key-service-m-idu-title');
        console.log('industrysInfo==', industrysInfo);
        this.industrysInfo = industrysInfo.data.baseData;

				const res2 = await itemList({ type: 2, limit: 6 });
				this.industrys = res2.data.baseData || [];
        console.log('index--this.industrys==', this.industrys);
        
        // this.$set(this, 'pageData', this.pageData);
        // console.log('join--this.pageData==', this.pageData);

			},


			async getData(type = 1) {
        const res = await indexDataList({ type })
        console.log('getData--res==', res);
        
				console.log(type, res.data.baseData);
				return res.data.baseData;
			},
			// async getAppInfo(key) {
			// 	const res = await this.$fetch('/app/info', { key });
			// 	console.log('getAppInfo--res==', res);
			// 	return res.data.baseData;
			// },
			async getBanner() {
        const bannerList = await bannerList2();
        console.log('bannerList==', bannerList);
					this.swipers = bannerList.data.baseData || [];
				// this.$fetch('/app/bannerList').then(res => {
				// 	console.log('index--getBanner--res==', res);
				// 	this.swipers = res.data.baseData || [];
				// 	console.log('index--this.swipers==', this.swipers);
				// })
      },
      clickProduct(item) {

      },
			openPage(url) {
        console.log('openPage--url==', url);
        
				if (!url) {
					return;
				}
				window.location.href = url;
      },
      openWindow(url) {
        if (!url) {
          return;
        }
        url = url.indexOf('https://') != 0 ? 'https://' + url : url;
        window.open(url);
      },
			changeServiceIndex(index, type) {
				if (type === 'businessIndex') {
					this.businessIndex = index
				} else if (type === 'serviceIndex') {
					this.serviceIndex = index;
				}
			},
			changeNav(item) {
				console.log('changeNav--item==', item);
				if (item.id === 'product') {
					// this.showProductMenu = !this.showProductMenu;
					this.showProductMenu = true;
				} else {
					this.showProductMenu = false;
				}
				this.activeNav = item.id;
				// this.$router.push({path: '/pages/product'})
			},
			handleOpen(e) {
				console.log('handleOpen--e==', e);
			},
			handleClose(e) {
				console.log('handleClose--e==', e);
			},
			visibleChange(bool) {
				console.log('visibleChange--bool==', bool);
				this.productList = this.productList.map(d => {
					d.open = false;
					return d;
				})
			},
			switchProduct(item, index) {
				console.log('switchProduct--item==', item);
				console.log('switchProduct--index==', index);
				console.log('switchProduct--this.productList==', this.productList);
				let row = JSON.parse(JSON.stringify(item));
				row.open = item.open ? false : true;
				this.$set(this.productList, index, row)
			},
			selProduct(e) {
				console.log('selProduct--e==', e);
			},
			// menuMouseover(e) {
			//   console.log('menuMouseover--e==', e);
			//   this.showProductMenu = true;
			// },
			// menuMouseout(e) {
			//   console.log('menuMouseout--e==', e);
			//   this.showProductMenu = false;
			// },

			// aboutUsOver(e) {
			//   console.log('aboutUsOver--e==', e);
			// },
			// aboutUsOut(e) {
			//   console.log('aboutUsOut--e==', e);
			// }
		}
	};
</script>

<style scoped lang="scss">
	@import "../common/css/style.scss";
	/deep/.banner-swiper .swiper-pagination {
		text-align: right !important;
		position: absolute !important;
		bottom: px2rem(90px) !important;
		right: px2rem(261px) !important;
	}
	/deep/.banner-swiper .swiper-pagination .swiper-pagination-bullet {
		width: 10px;
		height: 4px;
		border-radius: 4px;
		background: #1368df;
    opacity: 1;
    
	}
	/deep/.banner-swiper .swiper-pagination .swiper-pagination-bullet-active {
		background: #fff;
		width: 40px !important;
  }
  
	/deep/.el-carousel__item {
		img {
			width: 100px;
			height: 100px;
		}
	}

	.el-carousel__item h3 {
		color: #475669;
		font-size: 14px;
		opacity: 0.75;
		line-height: 200px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n + 1) {
		background-color: #d3dce6;
	}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue